import * as React from 'react';

export interface IOfferFactsInSidebarProps {
  children: React.ReactNode;
}

export const OfferFactsInSidebar: React.FC<React.PropsWithChildren<IOfferFactsInSidebarProps>> = ({ children }) => {
  return <div data-testid="offer-facts">{children}</div>;
};
